import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { markInputRule } from '../../utils';
import plugins from './plugins';

const STRONG_NODE_NAME = 'strong';
const BOLD_REGEX = /(?:\*\*)([^*]+)(?:\*\*)$/;

export default class Bold extends BaseExtension {
  get schema(): MarkSpec {
    return {
      parseDOM: [
        {
          tag: 'b',
          getAttrs: (element) => {
            const _element = element as HTMLElement;
            //adding font-weight is normal or 400 as patch to fix Google Docs wrapping text in b tag and giving it style font-weight=400
            if (_element.style.fontWeight === 'normal' || _element.style.fontWeight === '400') {
              return false;
            }

            return null;
          },
        },
        { tag: 'strong' },
        { tag: 'span.font-semibold' },
        {
          style: 'font-weight',
          getAttrs: (value) => {
            //adding font-weight is normal or 400 as patch to fix Google Docs wrapping text in b tag and giving it style font-weight=400
            if (value === 'normal' || value === '400') {
              return false;
            }

            return null;
          },
        },
      ],
      toDOM: () => ['span', { class: 'font-semibold' }, 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return STRONG_NODE_NAME;
  }

  inputRules({ schema }: EditorOptions) {
    return [markInputRule(BOLD_REGEX, schema.marks.strong)];
  }

  parseMarkdown(): void | ParseSpec {
    return {
      mark: STRONG_NODE_NAME,
    };
  }

  plugins = plugins;
}
